module.exports = __webpack_public_path__ + "media/images/about-bg-61cea9e7.jpeg";